import React, {ReactNode} from "react";
import {Outlet, Link} from "react-router-dom";
import {User} from "./User";
import {Dictionary} from "./Dictionary";
import {BoxArrowRight, TextIndentLeft} from 'react-bootstrap-icons';
import {adminMenu} from "../inc/AdminMenu";
import {AdminComponent} from "./AdminComponent";
import {RightAside} from "./Aside/RightAside";
import {StatusPage} from "../pages/StatusPage";
import {LoginPage} from "../pages/LoginPage";
import {Loader} from "./Loader";

//https://mui.com/joy-ui/getting-started/templates/order-dashboard/

export class AdminPanel extends React.Component<any, any> {
    private user: User = new User();
    private dictionary: Dictionary = new Dictionary();
    public static uriExceptions: string[] = [
        'settings/my-profile',
        'logout',
        'info/status',
        'info/all',
        'info/daily',
        'info/session',
        'info/main',
        'info/weekly'
    ];
    private pathName: string = window.location.pathname;
    private scrollLeftX: number | null = null;
    private touchstartX: number = 0;
    private touchstartY: number = 0;

    static get swipeYThreshold(): number {
        return 30;
    }

    componentDidMount() {
        document.addEventListener('touchstart', this.touchStart)
        document.addEventListener('touchend', this.touchEnd);
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.touchStart);
        document.removeEventListener('touchend', this.touchEnd);
    }

    render() {
        if (!this.user.valid()) {
            return (<LoginPage/>);
        }

        if ('/' === this.pathName) {
            window.location.assign('/' + Object.keys(adminMenu.right['home'])[0]);
            return (<Loader/>);
        }

        const aside = this.createAside();

        let outlet = <Outlet/>;

        if (aside.error !== null) {
            outlet = <StatusPage code={aside.error.code} message={aside.error.message}/>;
        }

        return (
            <div className="admin-page">
                <main>
                    <nav className="breadcrumbs">
                        <Link to="" onClick={this.openAside} className="openAdmin"><TextIndentLeft/></Link>
                        {aside.main ? aside.main : ''}
                        {aside.current ? aside.current : ''}
                        {/*<Link to="" onClick={this.switchClients} className="openAdmin"><ArrowLeftRight/></Link>*/}
                    </nav>
                    <div className="container-fluid">
                        {outlet}
                    </div>
                </main>
                <div className="aside-overlay" onClick={this.closeAside}>&nbsp;</div>
                <aside>
                    <nav className="aside-left">
                        {aside.left}
                    </nav>
                    <div className="aside-right">
                        {aside.right}
                    </div>
                    <div className="aside-bottom">
                        <p>
                            {this.user.name}
                            <br/>
                            <small>{this.user.email}</small>
                        </p>
                        <Link to="/logout"><BoxArrowRight/></Link>
                    </div>
                </aside>
                <RightAside/>
            </div>
        );
    }

    private switchClients(e: any): void {
        e.preventDefault()

    }

    private openAside(e: any): void {
        e.preventDefault()
        // @ts-ignore
        document.querySelector('.admin-page').classList.add('admin-page-open');
    }

    private closeAside(e: any): void {
        e.preventDefault()
        // @ts-ignore
        document.querySelector('.admin-page').classList.remove('admin-page-open');
    }

    private createAside(): {
        left: ReactNode,
        error: { code: number, message: string } | null,
        right: ReactNode,
        main: ReactNode | null,
        current: ReactNode | null
    } {
        let left = [], right = [],
            mainBreadcrumb = null, currentBreadcrumb = null, error = null;

        for (let id in adminMenu.right) {
            let rightList = [], mainActive = false;

            if ('/' + id === this.pathName) {
                this.pathName = '/' + Object.keys(adminMenu.right[id])[0];
                window.location.assign(this.pathName);
            }

            for (let key in adminMenu.right[id]) {

                const match = this.pathName.match(`^${adminMenu.right[id][key].path}$`);

                if (!this.user.rights.includes(key) && !AdminPanel.uriExceptions.includes(key)) {
                    if (match) {
                        error = {code: 403, message: 'forbidden'}
                    } else {
                        continue;
                    }
                }

                let active = false,
                    to = adminMenu.right[id][key].path,
                    className = adminMenu.right[id][key]?.hidden ? 'hide hidden' : '';

                if (match) {
                    active = mainActive = true;
                    className = adminMenu.right[id][key]?.hidden ? 'active hidden' : 'active';
                    to = this.pathName;
                    AdminComponent.params = match.slice(1);
                }

                rightList.push(<Link to={to} key={key} className={className}
                                     onClick={this.rightAsideClick}>
                    <span>{this.dictionary.get[adminMenu.right[id][key].name]}</span>
                    {adminMenu.right[id][key].icon}
                </Link>);

                if (active) {
                    currentBreadcrumb =
                        <Link to={to} key={key} className="current-breadCrumb" onClick={this.rightAsideBreadcrumbClick}>
                            {adminMenu.right[id][key].icon}
                            <span>{this.dictionary.get[adminMenu.right[id][key].name]}</span>
                        </Link>
                }
            }

            if (rightList.length === 0) {
                continue;
            }

            let navId = id + '-nav', className = mainActive ? 'active' : 'hide';

            right.push(<nav key={navId} data-key={id} className={className}>{rightList}</nav>);

            className = mainActive ? 'active' : '';

            left.push(<Link to={id} data-key={id} onClick={this.leftAsideClick} key={id} className={className}>
                {adminMenu.left[id].icon}<br/>
                <span>{this.dictionary.get[adminMenu.left[id].name]}</span>
            </Link>);

            if (mainActive) {
                mainBreadcrumb =
                    <Link to={id} data-key={id} onClick={this.leftAsideBreadcrumbClick} key={id}
                          className="main-breadCrumb">
                        {adminMenu.left[id].icon} <span>{this.dictionary.get[adminMenu.left[id].name]}</span>
                    </Link>
                ;
            }
        }

        return {left: left, right: right, main: mainBreadcrumb, current: currentBreadcrumb, error: error};
    }


    private touchStart(e: any) {
        this.scrollLeftX = e.target.closest('.table-responsive')?.scrollLeft;
        this.touchstartX = e.changedTouches[0].screenX;
        this.touchstartY = e.changedTouches[0].screenY;
    }

    private touchEnd(e: any) {
        const touchendX: number = e.changedTouches[0].screenX,
            touchendY: number = e.changedTouches[0].screenY,
            swipeX: number = this.touchstartX - touchendX;

        if (Math.abs(swipeX) < Math.abs(this.touchstartY - touchendY)) {
            return; // vertical swipe
        }

        if (touchendX < this.touchstartX && AdminPanel.swipeYThreshold < swipeX) {
            let adminPage = document.querySelector('.admin-page') as HTMLElement;
            if (adminPage.classList.contains('admin-page-open')) {
                adminPage.classList.remove('admin-page-open');
            }
        }

        if (this.scrollLeftX !== null && 0 < this.scrollLeftX) {
            return;
        }

        if (touchendX > this.touchstartX && AdminPanel.swipeYThreshold < Math.abs(swipeX)) {
            if (RightAside.isOpen || 20 > (touchendX - this.touchstartX)) {
                return;
            }
            let adminPage = document.querySelector('.admin-page') as HTMLElement;
            if (!adminPage.classList.contains('admin-page-open')) {
                adminPage.classList.add('admin-page-open');
            }
        }
    }

    private leftAsideBreadcrumbClick(event: any) {
        event.preventDefault();
        let adminPage = document.querySelector('.admin-page') as HTMLElement;
        if (!adminPage.classList.contains('admin-page-open')) {
            adminPage.classList.add('admin-page-open');
        }
        let target = event.target.nodeName === 'A' ? event.target : event.target.closest('a'),
            key = target.attributes['data-key'].value;
        document.querySelectorAll('.aside-right nav:not(.hide)').forEach(elem => {
            elem.classList.add("hide");
        });
        // @ts-ignore
        document.querySelector(`.aside-right nav[data-key="${key}"]`).classList.remove('hide');
    }

    private leftAsideClick(event: any) {
        event.preventDefault();

        let target = event.target.nodeName === 'A' ? event.target : event.target.closest('a'),
            key = target.attributes['data-key'].value;

        document.querySelectorAll('.aside-right nav:not(.hide)').forEach(elem => {
            elem.classList.add("hide");
        });

        (
            document.querySelector(`.aside-right nav[data-key="${key}"]`) as HTMLElement
        ).classList.remove('hide');
    };

    private rightAsideBreadcrumbClick(event: any) {
        event.preventDefault();
        let adminPage = document.querySelector('.admin-page') as HTMLElement;
        if (!adminPage.classList.contains('admin-page-open')) {
            adminPage.classList.add('admin-page-open');
        }
    }

    private rightAsideClick(event: any) {
        let target = event.target.nodeName === 'A' ? event.target : event.target.closest('a'),
            key = target.closest('nav').attributes['data-key'].value;

        document.querySelectorAll('.aside-right nav:not(.hide)').forEach(elem => {
            elem.classList.add("hide");
        });

        document.querySelectorAll('.aside-left a.active').forEach(elem => {
            elem.classList.remove("active");
        });

        // @ts-ignore
        document.querySelector(`.aside-left a[data-key="${key}"]`).classList.add('active');
        // @ts-ignore
        document.querySelector(`.aside-right nav[data-key="${key}"]`).classList.add('active');
        // @ts-ignore
        document.querySelector(`.aside-right nav[data-key="${key}"]`).classList.remove('hide');

        document.querySelectorAll(`.aside-right a.active`).forEach(link => {
            link.classList.remove("active");
            if (link.classList.contains('hidden')) {
                link.classList.add("hide");
            }
        });

        if (target.classList.contains('hidden')) {
            target.classList.remove("hide");
        }
        target.classList.add("active");

        let mainBreadcrumb: HTMLElement = document.querySelector('.main-breadCrumb') as HTMLElement;
        let mainLeft: HTMLElement = document.querySelector('.aside-left a.active') as HTMLElement;

        if (mainBreadcrumb) {
            // @ts-ignore
            mainBreadcrumb.innerHTML = mainLeft.querySelector('.bi').outerHTML + mainLeft.querySelector('span').outerHTML;

            mainBreadcrumb.setAttribute('href', mainLeft.getAttribute('href') || '');
            mainBreadcrumb.setAttribute('data-key', mainLeft.getAttribute('data-key') || '');
        }

        let currentBreadcrumb: HTMLElement = document.querySelector('.current-breadCrumb') as HTMLElement;
        if (currentBreadcrumb) {
            currentBreadcrumb.innerHTML = target.querySelector('.bi').outerHTML + target.querySelector('span').outerHTML;
            currentBreadcrumb.setAttribute('href', target.getAttribute('href'));
        }

        let adminPage = document.querySelector('.admin-page-open');
        if (adminPage) {
            adminPage.classList.remove('admin-page-open');
        }
    }
}
